<template>
  <div class="file-download">
    <div class="download-btn" v-if="!fileIsExist">
      <el-button round size="medium" type="primary" @click="handleDownload" v-if="progress <= 0">本地下载</el-button>
      <el-progress :text-inside="true" :stroke-width="20" :percentage="progress" v-else></el-progress>
      <p v-if="progress <= 0">请将该资源下载本地，以后可以随时看</p>
      <p v-else-if="progress == 1">正在获取文件资源，请稍后...</p>
      <p v-else>下载中...</p>
    </div>
    <div v-else>
      <el-button round size="medium" type="primary" @click="openFile">打开本地文件</el-button>
    </div>
  </div>
</template>

<script>
import {WinForm, ApiService} from '@/libs'

let baseUrl = '\\开放资源\\';

export default{
  props: {
    downloadPath: { default: '' },
    title: { default: '' },
    downloadFilekey: { default: 0 },
  },
  data() {
    return {
      downType: {},
      fileIsExist: false,
    }
  },
  watch: {
    'downloadPath': function(value) {
      this.existFile(value);
    }
  },
  computed: {
    progress() {
      const obj = this.downType[this.downloadFilekey] || {};
      return obj.progress || 0;
    }
  },
  mounted() {
    WinForm.md.$on('cloud_sass_downloadProgress', param => {
      this.downloadingProgress(param);
    });
    this.existFile();
  },
  methods: {
    existFile(path = '') {
      let existFile = WinForm.md.existFile(`${baseUrl}${path || this.downloadPath}`);
      this.fileIsExist = existFile;
    },
    openFile() {
      WinForm.md.openFile(`${baseUrl}${this.downloadPath}`);
    },

    handleDownload() {
      let downItem = {
        title: this.title,
        downUrl: `${ApiService.ImageHost}/std/${this.downloadPath}`,
        downTo: `${baseUrl}${this.downloadPath}`,
        saveTo: `${baseUrl}${this.downloadPath}`,
        downloadComplete: "downloadCloudSass",
        downloadArgs: {
          title: this.title,
          downloadPath: this.downloadPath,
          id: this.downloadFilekey,
        },
        downloadProgress: ['cloud_sass_downloadProgress']
      }
      WinForm.md.$emit("startDownItem", downItem);
    },

    downloadingProgress(param) {
      switch (param.status) {
        case "MD_DOWNLOAD":
        case "MD_COMPLETE":
          if (!this.downType[param.args.id]) {
            this.$set(this.downType, `${param.args.id}`, { progress: 1 })
          }
          this.downType[param.args.id].progress = param.progress ? param.progress : 1;
          if (param.progress >= 100) {
            this.fileIsExist = true;
          }
          break;
        default:
          this.downType[param.args.id].progress = 0;
          break;
      }
    },
  },
}
</script>

<style lang="less" scoped>
.file-download{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.download-btn{
  width: 260px;
  font-size: 14px;
  color: #2f3848;
  text-align: center;
  /deep/ .el-button{
    display: block;
    margin: 0 auto;
  }
}
</style>
